//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios'
import { BaseClient } from './baseclient'
import { ValidationProblemDetails,ApiException } from './ValidationProblemDetails'
export module del {

export class DemandeEnLigneClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param c (optional) 
     * @param noSuccursale (optional) 
     * @param lang (optional) 
     * @return OK
     */
    choix(c?: string | undefined, noSuccursale?: number | undefined, lang?: string | undefined, cancelToken?: CancelToken): Promise<DemandeViewModel> {
        let url_ = this.baseUrl + "/del/choix?";
        if (c === null)
            throw new globalThis.Error("The parameter 'c' cannot be null.");
        else if (c !== undefined)
            url_ += "c=" + encodeURIComponent("" + c) + "&";
        if (noSuccursale === null)
            throw new globalThis.Error("The parameter 'noSuccursale' cannot be null.");
        else if (noSuccursale !== undefined)
            url_ += "noSuccursale=" + encodeURIComponent("" + noSuccursale) + "&";
        if (lang === null)
            throw new globalThis.Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChoix(_response));
        });
    }

    protected processChoix(response: AxiosResponse): Promise<DemandeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DemandeViewModel.fromJS(resultData200);
            return Promise.resolve<DemandeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DemandeViewModel>(null as any);
    }

    /**
     * @param formValues (optional) 
     * @return OK
     */
    demande_en_ligne(formValues?: StringStringValuesKeyValuePair[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/del/demande_en_ligne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formValues === null || formValues === undefined)
            throw new globalThis.Error("The parameter 'formValues' cannot be null.");
        else
            formValues.forEach(item_ => content_.append("formValues", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDemande_en_ligne(_response));
        });
    }

    protected processDemande_en_ligne(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param mots (optional) 
     * @return OK
     */
    adresses(mots?: string | undefined, cancelToken?: CancelToken): Promise<AdresseResult[]> {
        let url_ = this.baseUrl + "/del/adresses?";
        if (mots === null)
            throw new globalThis.Error("The parameter 'mots' cannot be null.");
        else if (mots !== undefined)
            url_ += "mots=" + encodeURIComponent("" + mots) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAdresses(_response));
        });
    }

    protected processAdresses(response: AxiosResponse): Promise<AdresseResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdresseResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AdresseResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdresseResult[]>(null as any);
    }
}

export class Adresse implements IAdresse {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    noRue?: string | undefined;
    ville?: string | undefined;
    codePostal?: string | undefined;
    app?: string | undefined;
    adressePrecedente?: AdressePrecedente;

    constructor(data?: IAdresse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreation = _data["DateCreation"] ? new Date(_data["DateCreation"].toString()) : undefined as any;
            this.rowVersion = _data["RowVersion"];
            this.id = _data["Id"];
            this.noRue = _data["NoRue"];
            this.ville = _data["Ville"];
            this.codePostal = _data["CodePostal"];
            this.app = _data["App"];
            this.adressePrecedente = _data["AdressePrecedente"] ? AdressePrecedente.fromJS(_data["AdressePrecedente"]) : undefined as any;
        }
    }

    static fromJS(data: any): Adresse {
        data = typeof data === 'object' ? data : {};
        let result = new Adresse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["RowVersion"] = this.rowVersion;
        data["Id"] = this.id;
        data["NoRue"] = this.noRue;
        data["Ville"] = this.ville;
        data["CodePostal"] = this.codePostal;
        data["App"] = this.app;
        data["AdressePrecedente"] = this.adressePrecedente ? this.adressePrecedente.toJSON() : undefined as any;
        return data;
    }
}

export interface IAdresse {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    noRue?: string | undefined;
    ville?: string | undefined;
    codePostal?: string | undefined;
    app?: string | undefined;
    adressePrecedente?: AdressePrecedente;
}

export class AdressePrecedente implements IAdressePrecedente {
    id?: number;
    demandeId?: number;
    demande?: Demande;
    adresseId?: string;
    adresse?: Adresse;
    de?: DateDto;
    a?: DateDto;

    constructor(data?: IAdressePrecedente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.demandeId = _data["DemandeId"];
            this.demande = _data["Demande"] ? Demande.fromJS(_data["Demande"]) : undefined as any;
            this.adresseId = _data["AdresseId"];
            this.adresse = _data["Adresse"] ? Adresse.fromJS(_data["Adresse"]) : undefined as any;
            this.de = _data["De"] ? DateDto.fromJS(_data["De"]) : undefined as any;
            this.a = _data["A"] ? DateDto.fromJS(_data["A"]) : undefined as any;
        }
    }

    static fromJS(data: any): AdressePrecedente {
        data = typeof data === 'object' ? data : {};
        let result = new AdressePrecedente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DemandeId"] = this.demandeId;
        data["Demande"] = this.demande ? this.demande.toJSON() : undefined as any;
        data["AdresseId"] = this.adresseId;
        data["Adresse"] = this.adresse ? this.adresse.toJSON() : undefined as any;
        data["De"] = this.de ? this.de.toJSON() : undefined as any;
        data["A"] = this.a ? this.a.toJSON() : undefined as any;
        return data;
    }
}

export interface IAdressePrecedente {
    id?: number;
    demandeId?: number;
    demande?: Demande;
    adresseId?: string;
    adresse?: Adresse;
    de?: DateDto;
    a?: DateDto;
}

export class AdressePrecedenteModel implements IAdressePrecedenteModel {
    id?: string | undefined;
    noRue?: string | undefined;
    ville?: string | undefined;
    codePostal?: string | undefined;
    app?: string | undefined;
    dateDe?: Date;
    dateA?: Date;

    constructor(data?: IAdressePrecedenteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.noRue = _data["NoRue"];
            this.ville = _data["Ville"];
            this.codePostal = _data["CodePostal"];
            this.app = _data["App"];
            this.dateDe = _data["dateDe"] ? new Date(_data["dateDe"].toString()) : undefined as any;
            this.dateA = _data["dateA"] ? new Date(_data["dateA"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdressePrecedenteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdressePrecedenteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["NoRue"] = this.noRue;
        data["Ville"] = this.ville;
        data["CodePostal"] = this.codePostal;
        data["App"] = this.app;
        data["dateDe"] = this.dateDe ? this.dateDe.toISOString() : undefined as any;
        data["dateA"] = this.dateA ? this.dateA.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdressePrecedenteModel {
    id?: string | undefined;
    noRue?: string | undefined;
    ville?: string | undefined;
    codePostal?: string | undefined;
    app?: string | undefined;
    dateDe?: Date;
    dateA?: Date;
}

export class AdresseResult implements IAdresseResult {
    noRue?: string | undefined;
    ville?: string | undefined;
    codePostal?: string | undefined;
    app?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAdresseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noRue = _data["NoRue"];
            this.ville = _data["Ville"];
            this.codePostal = _data["CodePostal"];
            this.app = _data["App"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): AdresseResult {
        data = typeof data === 'object' ? data : {};
        let result = new AdresseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NoRue"] = this.noRue;
        data["Ville"] = this.ville;
        data["CodePostal"] = this.codePostal;
        data["App"] = this.app;
        data["Description"] = this.description;
        return data;
    }
}

export interface IAdresseResult {
    noRue?: string | undefined;
    ville?: string | undefined;
    codePostal?: string | undefined;
    app?: string | undefined;
    description?: string | undefined;
}

export class Autonomie implements IAutonomie {
    estAutonome?: boolean | undefined;
    aideRecue?: boolean | undefined;
    nbHeures?: string | undefined;
    organisme?: string | undefined;
    nomIntervenant?: string | undefined;

    constructor(data?: IAutonomie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estAutonome = _data["EstAutonome"];
            this.aideRecue = _data["AideRecue"];
            this.nbHeures = _data["NbHeures"];
            this.organisme = _data["Organisme"];
            this.nomIntervenant = _data["NomIntervenant"];
        }
    }

    static fromJS(data: any): Autonomie {
        data = typeof data === 'object' ? data : {};
        let result = new Autonomie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EstAutonome"] = this.estAutonome;
        data["AideRecue"] = this.aideRecue;
        data["NbHeures"] = this.nbHeures;
        data["Organisme"] = this.organisme;
        data["NomIntervenant"] = this.nomIntervenant;
        return data;
    }
}

export interface IAutonomie {
    estAutonome?: boolean | undefined;
    aideRecue?: boolean | undefined;
    nbHeures?: string | undefined;
    organisme?: string | undefined;
    nomIntervenant?: string | undefined;
}

export class Coop implements ICoop {
    estSelectionne?: boolean | undefined;
    impliqueDansOrganismeCommu?: string | undefined;
    rechercheResidencePourPersonneAgees?: boolean | undefined;
    disponibleCoopHabitation?: boolean | undefined;
    participationAtelierInformation?: boolean | undefined;
    inscritAtelier?: boolean | undefined;
    dateAtelier?: Date | undefined;
    informationAtelier?: boolean | undefined;
    explicationCoop?: string | undefined;
    projetParticulier?: string | undefined;
    serviceDesires?: string[] | undefined;
    responsabiliteCoop?: string[] | undefined;

    constructor(data?: ICoop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estSelectionne = _data["EstSelectionne"];
            this.impliqueDansOrganismeCommu = _data["ImpliqueDansOrganismeCommu"];
            this.rechercheResidencePourPersonneAgees = _data["RechercheResidencePourPersonneAgees"];
            this.disponibleCoopHabitation = _data["DisponibleCoopHabitation"];
            this.participationAtelierInformation = _data["ParticipationAtelierInformation"];
            this.inscritAtelier = _data["InscritAtelier"];
            this.dateAtelier = _data["DateAtelier"] ? new Date(_data["DateAtelier"].toString()) : undefined as any;
            this.informationAtelier = _data["InformationAtelier"];
            this.explicationCoop = _data["ExplicationCoop"];
            this.projetParticulier = _data["ProjetParticulier"];
            if (Array.isArray(_data["ServiceDesires"])) {
                this.serviceDesires = [] as any;
                for (let item of _data["ServiceDesires"])
                    this.serviceDesires!.push(item);
            }
            if (Array.isArray(_data["ResponsabiliteCoop"])) {
                this.responsabiliteCoop = [] as any;
                for (let item of _data["ResponsabiliteCoop"])
                    this.responsabiliteCoop!.push(item);
            }
        }
    }

    static fromJS(data: any): Coop {
        data = typeof data === 'object' ? data : {};
        let result = new Coop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EstSelectionne"] = this.estSelectionne;
        data["ImpliqueDansOrganismeCommu"] = this.impliqueDansOrganismeCommu;
        data["RechercheResidencePourPersonneAgees"] = this.rechercheResidencePourPersonneAgees;
        data["DisponibleCoopHabitation"] = this.disponibleCoopHabitation;
        data["ParticipationAtelierInformation"] = this.participationAtelierInformation;
        data["InscritAtelier"] = this.inscritAtelier;
        data["DateAtelier"] = this.dateAtelier ? this.dateAtelier.toISOString() : undefined as any;
        data["InformationAtelier"] = this.informationAtelier;
        data["ExplicationCoop"] = this.explicationCoop;
        data["ProjetParticulier"] = this.projetParticulier;
        if (Array.isArray(this.serviceDesires)) {
            data["ServiceDesires"] = [];
            for (let item of this.serviceDesires)
                data["ServiceDesires"].push(item);
        }
        if (Array.isArray(this.responsabiliteCoop)) {
            data["ResponsabiliteCoop"] = [];
            for (let item of this.responsabiliteCoop)
                data["ResponsabiliteCoop"].push(item);
        }
        return data;
    }
}

export interface ICoop {
    estSelectionne?: boolean | undefined;
    impliqueDansOrganismeCommu?: string | undefined;
    rechercheResidencePourPersonneAgees?: boolean | undefined;
    disponibleCoopHabitation?: boolean | undefined;
    participationAtelierInformation?: boolean | undefined;
    inscritAtelier?: boolean | undefined;
    dateAtelier?: Date | undefined;
    informationAtelier?: boolean | undefined;
    explicationCoop?: string | undefined;
    projetParticulier?: string | undefined;
    serviceDesires?: string[] | undefined;
    responsabiliteCoop?: string[] | undefined;
}

export class DateDto implements IDateDto {
    readonly value?: Date;

    constructor(data?: IDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).value = _data["Value"] ? new Date(_data["Value"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value ? this.value.toISOString() : undefined as any;
        return data;
    }
}

export interface IDateDto {
    value?: Date;
}

export class Demande implements IDemande {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    demandeId?: number;
    rowGuid?: string;
    codeOrganisme?: string | undefined;
    noSuccursale?: number;
    readonly codeDemande?: string | undefined;
    culture?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    telephoneDemandeur?: Telephone;
    telephoneAutre?: Telephone;
    courrielEmail?: string | undefined;
    dateNaissance?: DateDto;
    sexe?: string | undefined;
    nas?: string | undefined;
    personneAJoindre?: string | undefined;
    personneAJoindreTelephone?: Telephone;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;
    langue?: string | undefined;
    adresseActuelle?: Adresse;
    adresseActuelleDepuis?: DateDto;
    adressePrec?: Adresse;
    adressePrecDe?: DateDto;
    adressePrecA?: DateDto;
    adressesPrecedentes?: AdressePrecedente[] | undefined;
    typeDemandeur?: TypeDemandeur;
    nombrePieces?: string | undefined;
    loyerMensuel?: Money;
    serviceChauffage?: boolean;
    serviceElectricite?: boolean;
    serviceEauChaude?: boolean;
    serviceAutre?: boolean;
    nomProprietaire?: string | undefined;
    noProprietaire?: Telephone;
    soldeHypotheque?: string | undefined;
    typeChambreur?: TypeChambreur;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    persons?: Person[] | undefined;
    expulsion?: boolean | undefined;
    deguerpi?: boolean | undefined;
    detteHLM?: boolean | undefined;
    faillite?: boolean | undefined;
    punaise?: boolean | undefined;
    valeurtotal?: boolean | undefined;
    readonly possedeVoiture?: boolean | undefined;
    vehicules?: Vehicule[] | undefined;
    autonomieTachesMenages?: Autonomie;
    autonomieHygiene?: Autonomie;
    autonomieSante?: Autonomie;
    autonomieRepas?: Autonomie;
    territoiresSelectionnes?: string[] | undefined;
    estHlmPslPrive?: boolean;
    rechercheResidencePersonnesAgeesAvecServices?: boolean | undefined;
    projetParticulier?: string | undefined;
    obnl?: Obnl;
    coop?: Coop;
    utiliseProgrammeHlm?: boolean;
    utiliseProgrammeCoop?: boolean;
    utiliseProgrammeObnl?: boolean;
    fichierJoints?: FichierJoint[] | undefined;
    encadrementNecessaire?: string | undefined;
    autreCommentaire?: string | undefined;
    readonly etesVousDemandeur?: boolean;
    prenomDemandeurPour?: string | undefined;
    nomDemandeurPour?: string | undefined;
    lienDemandeurPour?: string | undefined;
    telephoneDemandeurPour?: Telephone;
    courrielDemandeurPourEmail?: string | undefined;
    readonly confirmAutorisation?: boolean;
    accepteRenseignements?: boolean;
    accepteVerificationsOmh?: boolean;
    readonly adresseCourrielConfirmation?: string | undefined;

    constructor(data?: IDemande) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreation = _data["DateCreation"] ? new Date(_data["DateCreation"].toString()) : undefined as any;
            this.rowVersion = _data["RowVersion"];
            this.demandeId = _data["DemandeId"];
            this.rowGuid = _data["RowGuid"];
            this.codeOrganisme = _data["CodeOrganisme"];
            this.noSuccursale = _data["NoSuccursale"];
            (this as any).codeDemande = _data["CodeDemande"];
            this.culture = _data["Culture"];
            this.prenom = _data["Prenom"];
            this.nom = _data["Nom"];
            this.telephoneDemandeur = _data["TelephoneDemandeur"] ? Telephone.fromJS(_data["TelephoneDemandeur"]) : undefined as any;
            this.telephoneAutre = _data["TelephoneAutre"] ? Telephone.fromJS(_data["TelephoneAutre"]) : undefined as any;
            this.courrielEmail = _data["CourrielEmail"];
            this.dateNaissance = _data["DateNaissance"] ? DateDto.fromJS(_data["DateNaissance"]) : undefined as any;
            this.sexe = _data["Sexe"];
            this.nas = _data["Nas"];
            this.personneAJoindre = _data["PersonneAJoindre"];
            this.personneAJoindreTelephone = _data["PersonneAJoindreTelephone"] ? Telephone.fromJS(_data["PersonneAJoindreTelephone"]) : undefined as any;
            this.statutDeResidence = _data["StatutDeResidence"];
            this.paysDeNaissance = _data["PaysDeNaissance"];
            this.langue = _data["Langue"];
            this.adresseActuelle = _data["AdresseActuelle"] ? Adresse.fromJS(_data["AdresseActuelle"]) : undefined as any;
            this.adresseActuelleDepuis = _data["AdresseActuelleDepuis"] ? DateDto.fromJS(_data["AdresseActuelleDepuis"]) : undefined as any;
            this.adressePrec = _data["AdressePrec"] ? Adresse.fromJS(_data["AdressePrec"]) : undefined as any;
            this.adressePrecDe = _data["AdressePrecDe"] ? DateDto.fromJS(_data["AdressePrecDe"]) : undefined as any;
            this.adressePrecA = _data["AdressePrecA"] ? DateDto.fromJS(_data["AdressePrecA"]) : undefined as any;
            if (Array.isArray(_data["AdressesPrecedentes"])) {
                this.adressesPrecedentes = [] as any;
                for (let item of _data["AdressesPrecedentes"])
                    this.adressesPrecedentes!.push(AdressePrecedente.fromJS(item));
            }
            this.typeDemandeur = _data["TypeDemandeur"] ? TypeDemandeur.fromJS(_data["TypeDemandeur"]) : undefined as any;
            this.nombrePieces = _data["NombrePieces"];
            this.loyerMensuel = _data["LoyerMensuel"] ? Money.fromJS(_data["LoyerMensuel"]) : undefined as any;
            this.serviceChauffage = _data["ServiceChauffage"];
            this.serviceElectricite = _data["ServiceElectricite"];
            this.serviceEauChaude = _data["ServiceEauChaude"];
            this.serviceAutre = _data["ServiceAutre"];
            this.nomProprietaire = _data["NomProprietaire"];
            this.noProprietaire = _data["NoProprietaire"] ? Telephone.fromJS(_data["NoProprietaire"]) : undefined as any;
            this.soldeHypotheque = _data["SoldeHypotheque"];
            this.typeChambreur = _data["TypeChambreur"] ? TypeChambreur.fromJS(_data["TypeChambreur"]) : undefined as any;
            this.etudiantTempsPlein = _data["EtudiantTempsPlein"];
            this.etudiantTempsPartiel = _data["EtudiantTempsPartiel"];
            this.handicapMoteur = _data["HandicapMoteur"];
            this.pensionAlimentaire = _data["PensionAlimentaire"];
            this.pensionVeteran = _data["PensionVeteran"];
            this.assuranceInvalidite = _data["AssuranceInvalidite"];
            if (Array.isArray(_data["Persons"])) {
                this.persons = [] as any;
                for (let item of _data["Persons"])
                    this.persons!.push(Person.fromJS(item));
            }
            this.expulsion = _data["Expulsion"];
            this.deguerpi = _data["Deguerpi"];
            this.detteHLM = _data["DetteHLM"];
            this.faillite = _data["Faillite"];
            this.punaise = _data["Punaise"];
            this.valeurtotal = _data["Valeurtotal"];
            (this as any).possedeVoiture = _data["PossedeVoiture"];
            if (Array.isArray(_data["Vehicules"])) {
                this.vehicules = [] as any;
                for (let item of _data["Vehicules"])
                    this.vehicules!.push(Vehicule.fromJS(item));
            }
            this.autonomieTachesMenages = _data["AutonomieTachesMenages"] ? Autonomie.fromJS(_data["AutonomieTachesMenages"]) : undefined as any;
            this.autonomieHygiene = _data["AutonomieHygiene"] ? Autonomie.fromJS(_data["AutonomieHygiene"]) : undefined as any;
            this.autonomieSante = _data["AutonomieSante"] ? Autonomie.fromJS(_data["AutonomieSante"]) : undefined as any;
            this.autonomieRepas = _data["AutonomieRepas"] ? Autonomie.fromJS(_data["AutonomieRepas"]) : undefined as any;
            if (Array.isArray(_data["TerritoiresSelectionnes"])) {
                this.territoiresSelectionnes = [] as any;
                for (let item of _data["TerritoiresSelectionnes"])
                    this.territoiresSelectionnes!.push(item);
            }
            this.estHlmPslPrive = _data["EstHlmPslPrive"];
            this.rechercheResidencePersonnesAgeesAvecServices = _data["RechercheResidencePersonnesAgeesAvecServices"];
            this.projetParticulier = _data["ProjetParticulier"];
            this.obnl = _data["Obnl"] ? Obnl.fromJS(_data["Obnl"]) : undefined as any;
            this.coop = _data["Coop"] ? Coop.fromJS(_data["Coop"]) : undefined as any;
            this.utiliseProgrammeHlm = _data["UtiliseProgrammeHlm"];
            this.utiliseProgrammeCoop = _data["UtiliseProgrammeCoop"];
            this.utiliseProgrammeObnl = _data["UtiliseProgrammeObnl"];
            if (Array.isArray(_data["FichierJoints"])) {
                this.fichierJoints = [] as any;
                for (let item of _data["FichierJoints"])
                    this.fichierJoints!.push(FichierJoint.fromJS(item));
            }
            this.encadrementNecessaire = _data["EncadrementNecessaire"];
            this.autreCommentaire = _data["AutreCommentaire"];
            (this as any).etesVousDemandeur = _data["EtesVousDemandeur"];
            this.prenomDemandeurPour = _data["PrenomDemandeurPour"];
            this.nomDemandeurPour = _data["NomDemandeurPour"];
            this.lienDemandeurPour = _data["LienDemandeurPour"];
            this.telephoneDemandeurPour = _data["TelephoneDemandeurPour"] ? Telephone.fromJS(_data["TelephoneDemandeurPour"]) : undefined as any;
            this.courrielDemandeurPourEmail = _data["CourrielDemandeurPourEmail"];
            (this as any).confirmAutorisation = _data["ConfirmAutorisation"];
            this.accepteRenseignements = _data["AccepteRenseignements"];
            this.accepteVerificationsOmh = _data["AccepteVerificationsOmh"];
            (this as any).adresseCourrielConfirmation = _data["AdresseCourrielConfirmation"];
        }
    }

    static fromJS(data: any): Demande {
        data = typeof data === 'object' ? data : {};
        let result = new Demande();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["RowVersion"] = this.rowVersion;
        data["DemandeId"] = this.demandeId;
        data["RowGuid"] = this.rowGuid;
        data["CodeOrganisme"] = this.codeOrganisme;
        data["NoSuccursale"] = this.noSuccursale;
        data["CodeDemande"] = this.codeDemande;
        data["Culture"] = this.culture;
        data["Prenom"] = this.prenom;
        data["Nom"] = this.nom;
        data["TelephoneDemandeur"] = this.telephoneDemandeur ? this.telephoneDemandeur.toJSON() : undefined as any;
        data["TelephoneAutre"] = this.telephoneAutre ? this.telephoneAutre.toJSON() : undefined as any;
        data["CourrielEmail"] = this.courrielEmail;
        data["DateNaissance"] = this.dateNaissance ? this.dateNaissance.toJSON() : undefined as any;
        data["Sexe"] = this.sexe;
        data["Nas"] = this.nas;
        data["PersonneAJoindre"] = this.personneAJoindre;
        data["PersonneAJoindreTelephone"] = this.personneAJoindreTelephone ? this.personneAJoindreTelephone.toJSON() : undefined as any;
        data["StatutDeResidence"] = this.statutDeResidence;
        data["PaysDeNaissance"] = this.paysDeNaissance;
        data["Langue"] = this.langue;
        data["AdresseActuelle"] = this.adresseActuelle ? this.adresseActuelle.toJSON() : undefined as any;
        data["AdresseActuelleDepuis"] = this.adresseActuelleDepuis ? this.adresseActuelleDepuis.toJSON() : undefined as any;
        data["AdressePrec"] = this.adressePrec ? this.adressePrec.toJSON() : undefined as any;
        data["AdressePrecDe"] = this.adressePrecDe ? this.adressePrecDe.toJSON() : undefined as any;
        data["AdressePrecA"] = this.adressePrecA ? this.adressePrecA.toJSON() : undefined as any;
        if (Array.isArray(this.adressesPrecedentes)) {
            data["AdressesPrecedentes"] = [];
            for (let item of this.adressesPrecedentes)
                data["AdressesPrecedentes"].push(item ? item.toJSON() : undefined as any);
        }
        data["TypeDemandeur"] = this.typeDemandeur ? this.typeDemandeur.toJSON() : undefined as any;
        data["NombrePieces"] = this.nombrePieces;
        data["LoyerMensuel"] = this.loyerMensuel ? this.loyerMensuel.toJSON() : undefined as any;
        data["ServiceChauffage"] = this.serviceChauffage;
        data["ServiceElectricite"] = this.serviceElectricite;
        data["ServiceEauChaude"] = this.serviceEauChaude;
        data["ServiceAutre"] = this.serviceAutre;
        data["NomProprietaire"] = this.nomProprietaire;
        data["NoProprietaire"] = this.noProprietaire ? this.noProprietaire.toJSON() : undefined as any;
        data["SoldeHypotheque"] = this.soldeHypotheque;
        data["TypeChambreur"] = this.typeChambreur ? this.typeChambreur.toJSON() : undefined as any;
        data["EtudiantTempsPlein"] = this.etudiantTempsPlein;
        data["EtudiantTempsPartiel"] = this.etudiantTempsPartiel;
        data["HandicapMoteur"] = this.handicapMoteur;
        data["PensionAlimentaire"] = this.pensionAlimentaire;
        data["PensionVeteran"] = this.pensionVeteran;
        data["AssuranceInvalidite"] = this.assuranceInvalidite;
        if (Array.isArray(this.persons)) {
            data["Persons"] = [];
            for (let item of this.persons)
                data["Persons"].push(item ? item.toJSON() : undefined as any);
        }
        data["Expulsion"] = this.expulsion;
        data["Deguerpi"] = this.deguerpi;
        data["DetteHLM"] = this.detteHLM;
        data["Faillite"] = this.faillite;
        data["Punaise"] = this.punaise;
        data["Valeurtotal"] = this.valeurtotal;
        data["PossedeVoiture"] = this.possedeVoiture;
        if (Array.isArray(this.vehicules)) {
            data["Vehicules"] = [];
            for (let item of this.vehicules)
                data["Vehicules"].push(item ? item.toJSON() : undefined as any);
        }
        data["AutonomieTachesMenages"] = this.autonomieTachesMenages ? this.autonomieTachesMenages.toJSON() : undefined as any;
        data["AutonomieHygiene"] = this.autonomieHygiene ? this.autonomieHygiene.toJSON() : undefined as any;
        data["AutonomieSante"] = this.autonomieSante ? this.autonomieSante.toJSON() : undefined as any;
        data["AutonomieRepas"] = this.autonomieRepas ? this.autonomieRepas.toJSON() : undefined as any;
        if (Array.isArray(this.territoiresSelectionnes)) {
            data["TerritoiresSelectionnes"] = [];
            for (let item of this.territoiresSelectionnes)
                data["TerritoiresSelectionnes"].push(item);
        }
        data["EstHlmPslPrive"] = this.estHlmPslPrive;
        data["RechercheResidencePersonnesAgeesAvecServices"] = this.rechercheResidencePersonnesAgeesAvecServices;
        data["ProjetParticulier"] = this.projetParticulier;
        data["Obnl"] = this.obnl ? this.obnl.toJSON() : undefined as any;
        data["Coop"] = this.coop ? this.coop.toJSON() : undefined as any;
        data["UtiliseProgrammeHlm"] = this.utiliseProgrammeHlm;
        data["UtiliseProgrammeCoop"] = this.utiliseProgrammeCoop;
        data["UtiliseProgrammeObnl"] = this.utiliseProgrammeObnl;
        if (Array.isArray(this.fichierJoints)) {
            data["FichierJoints"] = [];
            for (let item of this.fichierJoints)
                data["FichierJoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["EncadrementNecessaire"] = this.encadrementNecessaire;
        data["AutreCommentaire"] = this.autreCommentaire;
        data["EtesVousDemandeur"] = this.etesVousDemandeur;
        data["PrenomDemandeurPour"] = this.prenomDemandeurPour;
        data["NomDemandeurPour"] = this.nomDemandeurPour;
        data["LienDemandeurPour"] = this.lienDemandeurPour;
        data["TelephoneDemandeurPour"] = this.telephoneDemandeurPour ? this.telephoneDemandeurPour.toJSON() : undefined as any;
        data["CourrielDemandeurPourEmail"] = this.courrielDemandeurPourEmail;
        data["ConfirmAutorisation"] = this.confirmAutorisation;
        data["AccepteRenseignements"] = this.accepteRenseignements;
        data["AccepteVerificationsOmh"] = this.accepteVerificationsOmh;
        data["AdresseCourrielConfirmation"] = this.adresseCourrielConfirmation;
        return data;
    }
}

export interface IDemande {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    demandeId?: number;
    rowGuid?: string;
    codeOrganisme?: string | undefined;
    noSuccursale?: number;
    codeDemande?: string | undefined;
    culture?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    telephoneDemandeur?: Telephone;
    telephoneAutre?: Telephone;
    courrielEmail?: string | undefined;
    dateNaissance?: DateDto;
    sexe?: string | undefined;
    nas?: string | undefined;
    personneAJoindre?: string | undefined;
    personneAJoindreTelephone?: Telephone;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;
    langue?: string | undefined;
    adresseActuelle?: Adresse;
    adresseActuelleDepuis?: DateDto;
    adressePrec?: Adresse;
    adressePrecDe?: DateDto;
    adressePrecA?: DateDto;
    adressesPrecedentes?: AdressePrecedente[] | undefined;
    typeDemandeur?: TypeDemandeur;
    nombrePieces?: string | undefined;
    loyerMensuel?: Money;
    serviceChauffage?: boolean;
    serviceElectricite?: boolean;
    serviceEauChaude?: boolean;
    serviceAutre?: boolean;
    nomProprietaire?: string | undefined;
    noProprietaire?: Telephone;
    soldeHypotheque?: string | undefined;
    typeChambreur?: TypeChambreur;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    persons?: Person[] | undefined;
    expulsion?: boolean | undefined;
    deguerpi?: boolean | undefined;
    detteHLM?: boolean | undefined;
    faillite?: boolean | undefined;
    punaise?: boolean | undefined;
    valeurtotal?: boolean | undefined;
    possedeVoiture?: boolean | undefined;
    vehicules?: Vehicule[] | undefined;
    autonomieTachesMenages?: Autonomie;
    autonomieHygiene?: Autonomie;
    autonomieSante?: Autonomie;
    autonomieRepas?: Autonomie;
    territoiresSelectionnes?: string[] | undefined;
    estHlmPslPrive?: boolean;
    rechercheResidencePersonnesAgeesAvecServices?: boolean | undefined;
    projetParticulier?: string | undefined;
    obnl?: Obnl;
    coop?: Coop;
    utiliseProgrammeHlm?: boolean;
    utiliseProgrammeCoop?: boolean;
    utiliseProgrammeObnl?: boolean;
    fichierJoints?: FichierJoint[] | undefined;
    encadrementNecessaire?: string | undefined;
    autreCommentaire?: string | undefined;
    etesVousDemandeur?: boolean;
    prenomDemandeurPour?: string | undefined;
    nomDemandeurPour?: string | undefined;
    lienDemandeurPour?: string | undefined;
    telephoneDemandeurPour?: Telephone;
    courrielDemandeurPourEmail?: string | undefined;
    confirmAutorisation?: boolean;
    accepteRenseignements?: boolean;
    accepteVerificationsOmh?: boolean;
    adresseCourrielConfirmation?: string | undefined;
}

export class DemandeViewModel implements IDemandeViewModel {
    demandeId?: number;
    rowGuid?: string | undefined;
    codeOrganisme?: string | undefined;
    noSuccursale?: number;
    codeDemandeWeb?: string | undefined;
    culture?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    telephoneDemandeur?: Telephone;
    telephoneAutre?: Telephone;
    courrielEmail?: string | undefined;
    dateNaissance?: Date;
    sexe?: string | undefined;
    nas?: string | undefined;
    revenuTotal?: Money;
    situation?: string | undefined;
    personneAJoindre?: string | undefined;
    personneAJoindreTelephone?: Telephone;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;
    langue?: string | undefined;
    adresseActuelle?: Adresse;
    adresseActuelleDepuis?: Date;
    adressePrec?: Adresse;
    adressePrecDe?: Date | undefined;
    adressePrecA?: Date | undefined;
    adressesPrecedentes?: AdressePrecedenteModel[] | undefined;
    typeDemandeur?: TypeDemandeur;
    nombrePieces?: string | undefined;
    loyerMensuel?: Money;
    serviceChauffage?: boolean;
    serviceElectricite?: boolean;
    serviceEauChaude?: boolean;
    serviceAutre?: boolean;
    nomProprietaire?: string | undefined;
    noProprietaire?: Telephone;
    soldeHypotheque?: string | undefined;
    typeChambreur?: TypeChambreur;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    utiliseGardePartagee?: boolean;
    persons?: PersonneModel[] | undefined;
    expulsion?: boolean | undefined;
    deguerpi?: boolean | undefined;
    detteHLM?: boolean | undefined;
    faillite?: boolean | undefined;
    punaise?: boolean | undefined;
    valeurtotal?: boolean | undefined;
    possedeVoiture?: boolean | undefined;
    vehicules?: Vehicule[] | undefined;
    autonomieTachesMenages?: Autonomie;
    autonomieHygiene?: Autonomie;
    autonomieSante?: Autonomie;
    autonomieRepas?: Autonomie;
    utiliseValeurBiens?: boolean;
    territoiresSelectionnes?: string[] | undefined;
    estHlmPslPrive?: boolean;
    obnl?: Obnl;
    coop?: Coop;
    utiliseProgrammeHlm?: boolean;
    utiliseProgrammeCoop?: boolean;
    utiliseAtelierFederationCoop?: boolean;
    utiliseProgrammeObnl?: boolean;
    possedePiecePreuveAge?: boolean | undefined;
    possedePieceRevenus?: boolean | undefined;
    fichierJoints?: FichierJoint[] | undefined;
    encadrementNecessaire?: string | undefined;
    autreCommentaire?: string | undefined;
    etesVousDemandeur?: boolean;
    prenomDemandeurPour?: string | undefined;
    nomDemandeurPour?: string | undefined;
    lienDemandeurPour?: string | undefined;
    telephoneDemandeurPour?: Telephone;
    courrielDemandeurPourEmail?: string | undefined;
    confirmAutorisation?: boolean;
    accepteRenseignements?: boolean;
    accepteVerificationsOmh?: boolean;
    lienParentePourGardePartagee?: string | undefined;
    adresseOrganisme?: string | undefined;
    courrielOrganisme?: string | undefined;
    telephoneOrganisme?: string | undefined;
    montantLiquiditeExcedant?: string | undefined;
    pourcentageGardePartage?: number;
    version?: VersionViewModel;
    validerSurOnglet?: boolean;
    fichiersJointsMaxBytes?: number;
    fichierJointMaxLongueurNom?: number;
    formulaireCompleteVisible?: boolean;
    utiliseMultilangue?: boolean;
    langues?: string[] | undefined;
    territoires?: ListItem[] | undefined;
    marquesVehicule?: ListItem[] | undefined;
    sexes?: ListItem[] | undefined;
    lienParentes?: ListItem[] | undefined;
    lienParentesEstSansSousTutelleChefOuConjointPossible?: string[] | undefined;
    paysNaissance?: ListItem[] | undefined;
    statutsResidence?: ListItem[] | undefined;
    listeTypeDeLogement?: ListItem[] | undefined;
    listeSoldeHypotheque?: ListItem[] | undefined;
    listePointServices?: ListItem[] | undefined;
    listeLangueParlee?: ListItem[] | undefined;
    listeSituation?: ListItem[] | undefined;
    lienParentesDemandeur?: ListItem[] | undefined;
    implicationOrganisme?: ListItem[] | undefined;
    serviceDesires?: ListItem[] | undefined;
    responsabiliteCoop?: ListItem[] | undefined;
    imageLogo?: ImageModel;
    imageIcone?: ImageModel;
    dicImageTerritoire?: { [key: string]: ImageModel; } | undefined;
    dicNomOrganisme?: { [key: string]: string; } | undefined;
    dicUrlSiteAccueil?: { [key: string]: string; } | undefined;
    dicUrlDocumentTerritoires?: { [key: string]: string; } | undefined;
    dicUrlDocumentPiecesJustificatives?: { [key: string]: string; } | undefined;

    constructor(data?: IDemandeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.demandeId = _data["DemandeId"];
            this.rowGuid = _data["RowGuid"];
            this.codeOrganisme = _data["CodeOrganisme"];
            this.noSuccursale = _data["NoSuccursale"];
            this.codeDemandeWeb = _data["CodeDemandeWeb"];
            this.culture = _data["Culture"];
            this.prenom = _data["Prenom"];
            this.nom = _data["Nom"];
            this.telephoneDemandeur = _data["TelephoneDemandeur"] ? Telephone.fromJS(_data["TelephoneDemandeur"]) : undefined as any;
            this.telephoneAutre = _data["TelephoneAutre"] ? Telephone.fromJS(_data["TelephoneAutre"]) : undefined as any;
            this.courrielEmail = _data["CourrielEmail"];
            this.dateNaissance = _data["DateNaissance"] ? new Date(_data["DateNaissance"].toString()) : undefined as any;
            this.sexe = _data["Sexe"];
            this.nas = _data["Nas"];
            this.revenuTotal = _data["RevenuTotal"] ? Money.fromJS(_data["RevenuTotal"]) : undefined as any;
            this.situation = _data["Situation"];
            this.personneAJoindre = _data["PersonneAJoindre"];
            this.personneAJoindreTelephone = _data["PersonneAJoindreTelephone"] ? Telephone.fromJS(_data["PersonneAJoindreTelephone"]) : undefined as any;
            this.statutDeResidence = _data["StatutDeResidence"];
            this.paysDeNaissance = _data["PaysDeNaissance"];
            this.langue = _data["Langue"];
            this.adresseActuelle = _data["AdresseActuelle"] ? Adresse.fromJS(_data["AdresseActuelle"]) : undefined as any;
            this.adresseActuelleDepuis = _data["AdresseActuelleDepuis"] ? new Date(_data["AdresseActuelleDepuis"].toString()) : undefined as any;
            this.adressePrec = _data["AdressePrec"] ? Adresse.fromJS(_data["AdressePrec"]) : undefined as any;
            this.adressePrecDe = _data["AdressePrecDe"] ? new Date(_data["AdressePrecDe"].toString()) : undefined as any;
            this.adressePrecA = _data["AdressePrecA"] ? new Date(_data["AdressePrecA"].toString()) : undefined as any;
            if (Array.isArray(_data["AdressesPrecedentes"])) {
                this.adressesPrecedentes = [] as any;
                for (let item of _data["AdressesPrecedentes"])
                    this.adressesPrecedentes!.push(AdressePrecedenteModel.fromJS(item));
            }
            this.typeDemandeur = _data["TypeDemandeur"] ? TypeDemandeur.fromJS(_data["TypeDemandeur"]) : undefined as any;
            this.nombrePieces = _data["NombrePieces"];
            this.loyerMensuel = _data["LoyerMensuel"] ? Money.fromJS(_data["LoyerMensuel"]) : undefined as any;
            this.serviceChauffage = _data["ServiceChauffage"];
            this.serviceElectricite = _data["ServiceElectricite"];
            this.serviceEauChaude = _data["ServiceEauChaude"];
            this.serviceAutre = _data["ServiceAutre"];
            this.nomProprietaire = _data["NomProprietaire"];
            this.noProprietaire = _data["NoProprietaire"] ? Telephone.fromJS(_data["NoProprietaire"]) : undefined as any;
            this.soldeHypotheque = _data["SoldeHypotheque"];
            this.typeChambreur = _data["TypeChambreur"] ? TypeChambreur.fromJS(_data["TypeChambreur"]) : undefined as any;
            this.etudiantTempsPlein = _data["EtudiantTempsPlein"];
            this.etudiantTempsPartiel = _data["EtudiantTempsPartiel"];
            this.handicapMoteur = _data["HandicapMoteur"];
            this.pensionAlimentaire = _data["PensionAlimentaire"];
            this.pensionVeteran = _data["PensionVeteran"];
            this.assuranceInvalidite = _data["AssuranceInvalidite"];
            this.utiliseGardePartagee = _data["UtiliseGardePartagee"];
            if (Array.isArray(_data["Persons"])) {
                this.persons = [] as any;
                for (let item of _data["Persons"])
                    this.persons!.push(PersonneModel.fromJS(item));
            }
            this.expulsion = _data["Expulsion"];
            this.deguerpi = _data["Deguerpi"];
            this.detteHLM = _data["DetteHLM"];
            this.faillite = _data["Faillite"];
            this.punaise = _data["Punaise"];
            this.valeurtotal = _data["Valeurtotal"];
            this.possedeVoiture = _data["PossedeVoiture"];
            if (Array.isArray(_data["Vehicules"])) {
                this.vehicules = [] as any;
                for (let item of _data["Vehicules"])
                    this.vehicules!.push(Vehicule.fromJS(item));
            }
            this.autonomieTachesMenages = _data["AutonomieTachesMenages"] ? Autonomie.fromJS(_data["AutonomieTachesMenages"]) : undefined as any;
            this.autonomieHygiene = _data["AutonomieHygiene"] ? Autonomie.fromJS(_data["AutonomieHygiene"]) : undefined as any;
            this.autonomieSante = _data["AutonomieSante"] ? Autonomie.fromJS(_data["AutonomieSante"]) : undefined as any;
            this.autonomieRepas = _data["AutonomieRepas"] ? Autonomie.fromJS(_data["AutonomieRepas"]) : undefined as any;
            this.utiliseValeurBiens = _data["UtiliseValeurBiens"];
            if (Array.isArray(_data["TerritoiresSelectionnes"])) {
                this.territoiresSelectionnes = [] as any;
                for (let item of _data["TerritoiresSelectionnes"])
                    this.territoiresSelectionnes!.push(item);
            }
            this.estHlmPslPrive = _data["EstHlmPslPrive"];
            this.obnl = _data["Obnl"] ? Obnl.fromJS(_data["Obnl"]) : undefined as any;
            this.coop = _data["Coop"] ? Coop.fromJS(_data["Coop"]) : undefined as any;
            this.utiliseProgrammeHlm = _data["UtiliseProgrammeHlm"];
            this.utiliseProgrammeCoop = _data["UtiliseProgrammeCoop"];
            this.utiliseAtelierFederationCoop = _data["UtiliseAtelierFederationCoop"];
            this.utiliseProgrammeObnl = _data["UtiliseProgrammeObnl"];
            this.possedePiecePreuveAge = _data["PossedePiecePreuveAge"];
            this.possedePieceRevenus = _data["PossedePieceRevenus"];
            if (Array.isArray(_data["FichierJoints"])) {
                this.fichierJoints = [] as any;
                for (let item of _data["FichierJoints"])
                    this.fichierJoints!.push(FichierJoint.fromJS(item));
            }
            this.encadrementNecessaire = _data["EncadrementNecessaire"];
            this.autreCommentaire = _data["AutreCommentaire"];
            this.etesVousDemandeur = _data["EtesVousDemandeur"];
            this.prenomDemandeurPour = _data["PrenomDemandeurPour"];
            this.nomDemandeurPour = _data["NomDemandeurPour"];
            this.lienDemandeurPour = _data["LienDemandeurPour"];
            this.telephoneDemandeurPour = _data["TelephoneDemandeurPour"] ? Telephone.fromJS(_data["TelephoneDemandeurPour"]) : undefined as any;
            this.courrielDemandeurPourEmail = _data["CourrielDemandeurPourEmail"];
            this.confirmAutorisation = _data["ConfirmAutorisation"];
            this.accepteRenseignements = _data["AccepteRenseignements"];
            this.accepteVerificationsOmh = _data["AccepteVerificationsOmh"];
            this.lienParentePourGardePartagee = _data["LienParentePourGardePartagee"];
            this.adresseOrganisme = _data["AdresseOrganisme"];
            this.courrielOrganisme = _data["CourrielOrganisme"];
            this.telephoneOrganisme = _data["TelephoneOrganisme"];
            this.montantLiquiditeExcedant = _data["MontantLiquiditeExcedant"];
            this.pourcentageGardePartage = _data["PourcentageGardePartage"];
            this.version = _data["Version"] ? VersionViewModel.fromJS(_data["Version"]) : undefined as any;
            this.validerSurOnglet = _data["ValiderSurOnglet"];
            this.fichiersJointsMaxBytes = _data["FichiersJointsMaxBytes"];
            this.fichierJointMaxLongueurNom = _data["FichierJointMaxLongueurNom"];
            this.formulaireCompleteVisible = _data["FormulaireCompleteVisible"];
            this.utiliseMultilangue = _data["UtiliseMultilangue"];
            if (Array.isArray(_data["Langues"])) {
                this.langues = [] as any;
                for (let item of _data["Langues"])
                    this.langues!.push(item);
            }
            if (Array.isArray(_data["Territoires"])) {
                this.territoires = [] as any;
                for (let item of _data["Territoires"])
                    this.territoires!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["MarquesVehicule"])) {
                this.marquesVehicule = [] as any;
                for (let item of _data["MarquesVehicule"])
                    this.marquesVehicule!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["Sexes"])) {
                this.sexes = [] as any;
                for (let item of _data["Sexes"])
                    this.sexes!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["LienParentes"])) {
                this.lienParentes = [] as any;
                for (let item of _data["LienParentes"])
                    this.lienParentes!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["LienParentesEstSansSousTutelleChefOuConjointPossible"])) {
                this.lienParentesEstSansSousTutelleChefOuConjointPossible = [] as any;
                for (let item of _data["LienParentesEstSansSousTutelleChefOuConjointPossible"])
                    this.lienParentesEstSansSousTutelleChefOuConjointPossible!.push(item);
            }
            if (Array.isArray(_data["PaysNaissance"])) {
                this.paysNaissance = [] as any;
                for (let item of _data["PaysNaissance"])
                    this.paysNaissance!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["StatutsResidence"])) {
                this.statutsResidence = [] as any;
                for (let item of _data["StatutsResidence"])
                    this.statutsResidence!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ListeTypeDeLogement"])) {
                this.listeTypeDeLogement = [] as any;
                for (let item of _data["ListeTypeDeLogement"])
                    this.listeTypeDeLogement!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ListeSoldeHypotheque"])) {
                this.listeSoldeHypotheque = [] as any;
                for (let item of _data["ListeSoldeHypotheque"])
                    this.listeSoldeHypotheque!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ListePointServices"])) {
                this.listePointServices = [] as any;
                for (let item of _data["ListePointServices"])
                    this.listePointServices!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ListeLangueParlee"])) {
                this.listeLangueParlee = [] as any;
                for (let item of _data["ListeLangueParlee"])
                    this.listeLangueParlee!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ListeSituation"])) {
                this.listeSituation = [] as any;
                for (let item of _data["ListeSituation"])
                    this.listeSituation!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["LienParentesDemandeur"])) {
                this.lienParentesDemandeur = [] as any;
                for (let item of _data["LienParentesDemandeur"])
                    this.lienParentesDemandeur!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ImplicationOrganisme"])) {
                this.implicationOrganisme = [] as any;
                for (let item of _data["ImplicationOrganisme"])
                    this.implicationOrganisme!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ServiceDesires"])) {
                this.serviceDesires = [] as any;
                for (let item of _data["ServiceDesires"])
                    this.serviceDesires!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["ResponsabiliteCoop"])) {
                this.responsabiliteCoop = [] as any;
                for (let item of _data["ResponsabiliteCoop"])
                    this.responsabiliteCoop!.push(ListItem.fromJS(item));
            }
            this.imageLogo = _data["ImageLogo"] ? ImageModel.fromJS(_data["ImageLogo"]) : undefined as any;
            this.imageIcone = _data["ImageIcone"] ? ImageModel.fromJS(_data["ImageIcone"]) : undefined as any;
            if (_data["DicImageTerritoire"]) {
                this.dicImageTerritoire = {} as any;
                for (let key in _data["DicImageTerritoire"]) {
                    if (_data["DicImageTerritoire"].hasOwnProperty(key))
                        (this.dicImageTerritoire as any)![key] = _data["DicImageTerritoire"][key] ? ImageModel.fromJS(_data["DicImageTerritoire"][key]) : new ImageModel();
                }
            }
            if (_data["DicNomOrganisme"]) {
                this.dicNomOrganisme = {} as any;
                for (let key in _data["DicNomOrganisme"]) {
                    if (_data["DicNomOrganisme"].hasOwnProperty(key))
                        (this.dicNomOrganisme as any)![key] = _data["DicNomOrganisme"][key];
                }
            }
            if (_data["DicUrlSiteAccueil"]) {
                this.dicUrlSiteAccueil = {} as any;
                for (let key in _data["DicUrlSiteAccueil"]) {
                    if (_data["DicUrlSiteAccueil"].hasOwnProperty(key))
                        (this.dicUrlSiteAccueil as any)![key] = _data["DicUrlSiteAccueil"][key];
                }
            }
            if (_data["DicUrlDocumentTerritoires"]) {
                this.dicUrlDocumentTerritoires = {} as any;
                for (let key in _data["DicUrlDocumentTerritoires"]) {
                    if (_data["DicUrlDocumentTerritoires"].hasOwnProperty(key))
                        (this.dicUrlDocumentTerritoires as any)![key] = _data["DicUrlDocumentTerritoires"][key];
                }
            }
            if (_data["DicUrlDocumentPiecesJustificatives"]) {
                this.dicUrlDocumentPiecesJustificatives = {} as any;
                for (let key in _data["DicUrlDocumentPiecesJustificatives"]) {
                    if (_data["DicUrlDocumentPiecesJustificatives"].hasOwnProperty(key))
                        (this.dicUrlDocumentPiecesJustificatives as any)![key] = _data["DicUrlDocumentPiecesJustificatives"][key];
                }
            }
        }
    }

    static fromJS(data: any): DemandeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DemandeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DemandeId"] = this.demandeId;
        data["RowGuid"] = this.rowGuid;
        data["CodeOrganisme"] = this.codeOrganisme;
        data["NoSuccursale"] = this.noSuccursale;
        data["CodeDemandeWeb"] = this.codeDemandeWeb;
        data["Culture"] = this.culture;
        data["Prenom"] = this.prenom;
        data["Nom"] = this.nom;
        data["TelephoneDemandeur"] = this.telephoneDemandeur ? this.telephoneDemandeur.toJSON() : undefined as any;
        data["TelephoneAutre"] = this.telephoneAutre ? this.telephoneAutre.toJSON() : undefined as any;
        data["CourrielEmail"] = this.courrielEmail;
        data["DateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        data["Sexe"] = this.sexe;
        data["Nas"] = this.nas;
        data["RevenuTotal"] = this.revenuTotal ? this.revenuTotal.toJSON() : undefined as any;
        data["Situation"] = this.situation;
        data["PersonneAJoindre"] = this.personneAJoindre;
        data["PersonneAJoindreTelephone"] = this.personneAJoindreTelephone ? this.personneAJoindreTelephone.toJSON() : undefined as any;
        data["StatutDeResidence"] = this.statutDeResidence;
        data["PaysDeNaissance"] = this.paysDeNaissance;
        data["Langue"] = this.langue;
        data["AdresseActuelle"] = this.adresseActuelle ? this.adresseActuelle.toJSON() : undefined as any;
        data["AdresseActuelleDepuis"] = this.adresseActuelleDepuis ? this.adresseActuelleDepuis.toISOString() : undefined as any;
        data["AdressePrec"] = this.adressePrec ? this.adressePrec.toJSON() : undefined as any;
        data["AdressePrecDe"] = this.adressePrecDe ? this.adressePrecDe.toISOString() : undefined as any;
        data["AdressePrecA"] = this.adressePrecA ? this.adressePrecA.toISOString() : undefined as any;
        if (Array.isArray(this.adressesPrecedentes)) {
            data["AdressesPrecedentes"] = [];
            for (let item of this.adressesPrecedentes)
                data["AdressesPrecedentes"].push(item ? item.toJSON() : undefined as any);
        }
        data["TypeDemandeur"] = this.typeDemandeur ? this.typeDemandeur.toJSON() : undefined as any;
        data["NombrePieces"] = this.nombrePieces;
        data["LoyerMensuel"] = this.loyerMensuel ? this.loyerMensuel.toJSON() : undefined as any;
        data["ServiceChauffage"] = this.serviceChauffage;
        data["ServiceElectricite"] = this.serviceElectricite;
        data["ServiceEauChaude"] = this.serviceEauChaude;
        data["ServiceAutre"] = this.serviceAutre;
        data["NomProprietaire"] = this.nomProprietaire;
        data["NoProprietaire"] = this.noProprietaire ? this.noProprietaire.toJSON() : undefined as any;
        data["SoldeHypotheque"] = this.soldeHypotheque;
        data["TypeChambreur"] = this.typeChambreur ? this.typeChambreur.toJSON() : undefined as any;
        data["EtudiantTempsPlein"] = this.etudiantTempsPlein;
        data["EtudiantTempsPartiel"] = this.etudiantTempsPartiel;
        data["HandicapMoteur"] = this.handicapMoteur;
        data["PensionAlimentaire"] = this.pensionAlimentaire;
        data["PensionVeteran"] = this.pensionVeteran;
        data["AssuranceInvalidite"] = this.assuranceInvalidite;
        data["UtiliseGardePartagee"] = this.utiliseGardePartagee;
        if (Array.isArray(this.persons)) {
            data["Persons"] = [];
            for (let item of this.persons)
                data["Persons"].push(item ? item.toJSON() : undefined as any);
        }
        data["Expulsion"] = this.expulsion;
        data["Deguerpi"] = this.deguerpi;
        data["DetteHLM"] = this.detteHLM;
        data["Faillite"] = this.faillite;
        data["Punaise"] = this.punaise;
        data["Valeurtotal"] = this.valeurtotal;
        data["PossedeVoiture"] = this.possedeVoiture;
        if (Array.isArray(this.vehicules)) {
            data["Vehicules"] = [];
            for (let item of this.vehicules)
                data["Vehicules"].push(item ? item.toJSON() : undefined as any);
        }
        data["AutonomieTachesMenages"] = this.autonomieTachesMenages ? this.autonomieTachesMenages.toJSON() : undefined as any;
        data["AutonomieHygiene"] = this.autonomieHygiene ? this.autonomieHygiene.toJSON() : undefined as any;
        data["AutonomieSante"] = this.autonomieSante ? this.autonomieSante.toJSON() : undefined as any;
        data["AutonomieRepas"] = this.autonomieRepas ? this.autonomieRepas.toJSON() : undefined as any;
        data["UtiliseValeurBiens"] = this.utiliseValeurBiens;
        if (Array.isArray(this.territoiresSelectionnes)) {
            data["TerritoiresSelectionnes"] = [];
            for (let item of this.territoiresSelectionnes)
                data["TerritoiresSelectionnes"].push(item);
        }
        data["EstHlmPslPrive"] = this.estHlmPslPrive;
        data["Obnl"] = this.obnl ? this.obnl.toJSON() : undefined as any;
        data["Coop"] = this.coop ? this.coop.toJSON() : undefined as any;
        data["UtiliseProgrammeHlm"] = this.utiliseProgrammeHlm;
        data["UtiliseProgrammeCoop"] = this.utiliseProgrammeCoop;
        data["UtiliseAtelierFederationCoop"] = this.utiliseAtelierFederationCoop;
        data["UtiliseProgrammeObnl"] = this.utiliseProgrammeObnl;
        data["PossedePiecePreuveAge"] = this.possedePiecePreuveAge;
        data["PossedePieceRevenus"] = this.possedePieceRevenus;
        if (Array.isArray(this.fichierJoints)) {
            data["FichierJoints"] = [];
            for (let item of this.fichierJoints)
                data["FichierJoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["EncadrementNecessaire"] = this.encadrementNecessaire;
        data["AutreCommentaire"] = this.autreCommentaire;
        data["EtesVousDemandeur"] = this.etesVousDemandeur;
        data["PrenomDemandeurPour"] = this.prenomDemandeurPour;
        data["NomDemandeurPour"] = this.nomDemandeurPour;
        data["LienDemandeurPour"] = this.lienDemandeurPour;
        data["TelephoneDemandeurPour"] = this.telephoneDemandeurPour ? this.telephoneDemandeurPour.toJSON() : undefined as any;
        data["CourrielDemandeurPourEmail"] = this.courrielDemandeurPourEmail;
        data["ConfirmAutorisation"] = this.confirmAutorisation;
        data["AccepteRenseignements"] = this.accepteRenseignements;
        data["AccepteVerificationsOmh"] = this.accepteVerificationsOmh;
        data["LienParentePourGardePartagee"] = this.lienParentePourGardePartagee;
        data["AdresseOrganisme"] = this.adresseOrganisme;
        data["CourrielOrganisme"] = this.courrielOrganisme;
        data["TelephoneOrganisme"] = this.telephoneOrganisme;
        data["MontantLiquiditeExcedant"] = this.montantLiquiditeExcedant;
        data["PourcentageGardePartage"] = this.pourcentageGardePartage;
        data["Version"] = this.version ? this.version.toJSON() : undefined as any;
        data["ValiderSurOnglet"] = this.validerSurOnglet;
        data["FichiersJointsMaxBytes"] = this.fichiersJointsMaxBytes;
        data["FichierJointMaxLongueurNom"] = this.fichierJointMaxLongueurNom;
        data["FormulaireCompleteVisible"] = this.formulaireCompleteVisible;
        data["UtiliseMultilangue"] = this.utiliseMultilangue;
        if (Array.isArray(this.langues)) {
            data["Langues"] = [];
            for (let item of this.langues)
                data["Langues"].push(item);
        }
        if (Array.isArray(this.territoires)) {
            data["Territoires"] = [];
            for (let item of this.territoires)
                data["Territoires"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.marquesVehicule)) {
            data["MarquesVehicule"] = [];
            for (let item of this.marquesVehicule)
                data["MarquesVehicule"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sexes)) {
            data["Sexes"] = [];
            for (let item of this.sexes)
                data["Sexes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lienParentes)) {
            data["LienParentes"] = [];
            for (let item of this.lienParentes)
                data["LienParentes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lienParentesEstSansSousTutelleChefOuConjointPossible)) {
            data["LienParentesEstSansSousTutelleChefOuConjointPossible"] = [];
            for (let item of this.lienParentesEstSansSousTutelleChefOuConjointPossible)
                data["LienParentesEstSansSousTutelleChefOuConjointPossible"].push(item);
        }
        if (Array.isArray(this.paysNaissance)) {
            data["PaysNaissance"] = [];
            for (let item of this.paysNaissance)
                data["PaysNaissance"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statutsResidence)) {
            data["StatutsResidence"] = [];
            for (let item of this.statutsResidence)
                data["StatutsResidence"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listeTypeDeLogement)) {
            data["ListeTypeDeLogement"] = [];
            for (let item of this.listeTypeDeLogement)
                data["ListeTypeDeLogement"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listeSoldeHypotheque)) {
            data["ListeSoldeHypotheque"] = [];
            for (let item of this.listeSoldeHypotheque)
                data["ListeSoldeHypotheque"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listePointServices)) {
            data["ListePointServices"] = [];
            for (let item of this.listePointServices)
                data["ListePointServices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listeLangueParlee)) {
            data["ListeLangueParlee"] = [];
            for (let item of this.listeLangueParlee)
                data["ListeLangueParlee"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listeSituation)) {
            data["ListeSituation"] = [];
            for (let item of this.listeSituation)
                data["ListeSituation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lienParentesDemandeur)) {
            data["LienParentesDemandeur"] = [];
            for (let item of this.lienParentesDemandeur)
                data["LienParentesDemandeur"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.implicationOrganisme)) {
            data["ImplicationOrganisme"] = [];
            for (let item of this.implicationOrganisme)
                data["ImplicationOrganisme"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceDesires)) {
            data["ServiceDesires"] = [];
            for (let item of this.serviceDesires)
                data["ServiceDesires"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.responsabiliteCoop)) {
            data["ResponsabiliteCoop"] = [];
            for (let item of this.responsabiliteCoop)
                data["ResponsabiliteCoop"].push(item ? item.toJSON() : undefined as any);
        }
        data["ImageLogo"] = this.imageLogo ? this.imageLogo.toJSON() : undefined as any;
        data["ImageIcone"] = this.imageIcone ? this.imageIcone.toJSON() : undefined as any;
        if (this.dicImageTerritoire) {
            data["DicImageTerritoire"] = {};
            for (let key in this.dicImageTerritoire) {
                if (this.dicImageTerritoire.hasOwnProperty(key))
                    (data["DicImageTerritoire"] as any)[key] = this.dicImageTerritoire[key] ? this.dicImageTerritoire[key].toJSON() : undefined as any;
            }
        }
        if (this.dicNomOrganisme) {
            data["DicNomOrganisme"] = {};
            for (let key in this.dicNomOrganisme) {
                if (this.dicNomOrganisme.hasOwnProperty(key))
                    (data["DicNomOrganisme"] as any)[key] = (this.dicNomOrganisme as any)[key];
            }
        }
        if (this.dicUrlSiteAccueil) {
            data["DicUrlSiteAccueil"] = {};
            for (let key in this.dicUrlSiteAccueil) {
                if (this.dicUrlSiteAccueil.hasOwnProperty(key))
                    (data["DicUrlSiteAccueil"] as any)[key] = (this.dicUrlSiteAccueil as any)[key];
            }
        }
        if (this.dicUrlDocumentTerritoires) {
            data["DicUrlDocumentTerritoires"] = {};
            for (let key in this.dicUrlDocumentTerritoires) {
                if (this.dicUrlDocumentTerritoires.hasOwnProperty(key))
                    (data["DicUrlDocumentTerritoires"] as any)[key] = (this.dicUrlDocumentTerritoires as any)[key];
            }
        }
        if (this.dicUrlDocumentPiecesJustificatives) {
            data["DicUrlDocumentPiecesJustificatives"] = {};
            for (let key in this.dicUrlDocumentPiecesJustificatives) {
                if (this.dicUrlDocumentPiecesJustificatives.hasOwnProperty(key))
                    (data["DicUrlDocumentPiecesJustificatives"] as any)[key] = (this.dicUrlDocumentPiecesJustificatives as any)[key];
            }
        }
        return data;
    }
}

export interface IDemandeViewModel {
    demandeId?: number;
    rowGuid?: string | undefined;
    codeOrganisme?: string | undefined;
    noSuccursale?: number;
    codeDemandeWeb?: string | undefined;
    culture?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    telephoneDemandeur?: Telephone;
    telephoneAutre?: Telephone;
    courrielEmail?: string | undefined;
    dateNaissance?: Date;
    sexe?: string | undefined;
    nas?: string | undefined;
    revenuTotal?: Money;
    situation?: string | undefined;
    personneAJoindre?: string | undefined;
    personneAJoindreTelephone?: Telephone;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;
    langue?: string | undefined;
    adresseActuelle?: Adresse;
    adresseActuelleDepuis?: Date;
    adressePrec?: Adresse;
    adressePrecDe?: Date | undefined;
    adressePrecA?: Date | undefined;
    adressesPrecedentes?: AdressePrecedenteModel[] | undefined;
    typeDemandeur?: TypeDemandeur;
    nombrePieces?: string | undefined;
    loyerMensuel?: Money;
    serviceChauffage?: boolean;
    serviceElectricite?: boolean;
    serviceEauChaude?: boolean;
    serviceAutre?: boolean;
    nomProprietaire?: string | undefined;
    noProprietaire?: Telephone;
    soldeHypotheque?: string | undefined;
    typeChambreur?: TypeChambreur;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    utiliseGardePartagee?: boolean;
    persons?: PersonneModel[] | undefined;
    expulsion?: boolean | undefined;
    deguerpi?: boolean | undefined;
    detteHLM?: boolean | undefined;
    faillite?: boolean | undefined;
    punaise?: boolean | undefined;
    valeurtotal?: boolean | undefined;
    possedeVoiture?: boolean | undefined;
    vehicules?: Vehicule[] | undefined;
    autonomieTachesMenages?: Autonomie;
    autonomieHygiene?: Autonomie;
    autonomieSante?: Autonomie;
    autonomieRepas?: Autonomie;
    utiliseValeurBiens?: boolean;
    territoiresSelectionnes?: string[] | undefined;
    estHlmPslPrive?: boolean;
    obnl?: Obnl;
    coop?: Coop;
    utiliseProgrammeHlm?: boolean;
    utiliseProgrammeCoop?: boolean;
    utiliseAtelierFederationCoop?: boolean;
    utiliseProgrammeObnl?: boolean;
    possedePiecePreuveAge?: boolean | undefined;
    possedePieceRevenus?: boolean | undefined;
    fichierJoints?: FichierJoint[] | undefined;
    encadrementNecessaire?: string | undefined;
    autreCommentaire?: string | undefined;
    etesVousDemandeur?: boolean;
    prenomDemandeurPour?: string | undefined;
    nomDemandeurPour?: string | undefined;
    lienDemandeurPour?: string | undefined;
    telephoneDemandeurPour?: Telephone;
    courrielDemandeurPourEmail?: string | undefined;
    confirmAutorisation?: boolean;
    accepteRenseignements?: boolean;
    accepteVerificationsOmh?: boolean;
    lienParentePourGardePartagee?: string | undefined;
    adresseOrganisme?: string | undefined;
    courrielOrganisme?: string | undefined;
    telephoneOrganisme?: string | undefined;
    montantLiquiditeExcedant?: string | undefined;
    pourcentageGardePartage?: number;
    version?: VersionViewModel;
    validerSurOnglet?: boolean;
    fichiersJointsMaxBytes?: number;
    fichierJointMaxLongueurNom?: number;
    formulaireCompleteVisible?: boolean;
    utiliseMultilangue?: boolean;
    langues?: string[] | undefined;
    territoires?: ListItem[] | undefined;
    marquesVehicule?: ListItem[] | undefined;
    sexes?: ListItem[] | undefined;
    lienParentes?: ListItem[] | undefined;
    lienParentesEstSansSousTutelleChefOuConjointPossible?: string[] | undefined;
    paysNaissance?: ListItem[] | undefined;
    statutsResidence?: ListItem[] | undefined;
    listeTypeDeLogement?: ListItem[] | undefined;
    listeSoldeHypotheque?: ListItem[] | undefined;
    listePointServices?: ListItem[] | undefined;
    listeLangueParlee?: ListItem[] | undefined;
    listeSituation?: ListItem[] | undefined;
    lienParentesDemandeur?: ListItem[] | undefined;
    implicationOrganisme?: ListItem[] | undefined;
    serviceDesires?: ListItem[] | undefined;
    responsabiliteCoop?: ListItem[] | undefined;
    imageLogo?: ImageModel;
    imageIcone?: ImageModel;
    dicImageTerritoire?: { [key: string]: ImageModel; } | undefined;
    dicNomOrganisme?: { [key: string]: string; } | undefined;
    dicUrlSiteAccueil?: { [key: string]: string; } | undefined;
    dicUrlDocumentTerritoires?: { [key: string]: string; } | undefined;
    dicUrlDocumentPiecesJustificatives?: { [key: string]: string; } | undefined;
}

export class FichierJoint implements IFichierJoint {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    nom?: string | undefined;
    originalFilename?: string | undefined;
    size?: number;
    content?: string | undefined;
    demandeGuid?: string;
    demandeId?: number;

    constructor(data?: IFichierJoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreation = _data["DateCreation"] ? new Date(_data["DateCreation"].toString()) : undefined as any;
            this.rowVersion = _data["RowVersion"];
            this.id = _data["Id"];
            this.nom = _data["Nom"];
            this.originalFilename = _data["OriginalFilename"];
            this.size = _data["Size"];
            this.content = _data["Content"];
            this.demandeGuid = _data["DemandeGuid"];
            this.demandeId = _data["DemandeId"];
        }
    }

    static fromJS(data: any): FichierJoint {
        data = typeof data === 'object' ? data : {};
        let result = new FichierJoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["RowVersion"] = this.rowVersion;
        data["Id"] = this.id;
        data["Nom"] = this.nom;
        data["OriginalFilename"] = this.originalFilename;
        data["Size"] = this.size;
        data["Content"] = this.content;
        data["DemandeGuid"] = this.demandeGuid;
        data["DemandeId"] = this.demandeId;
        return data;
    }
}

export interface IFichierJoint {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    nom?: string | undefined;
    originalFilename?: string | undefined;
    size?: number;
    content?: string | undefined;
    demandeGuid?: string;
    demandeId?: number;
}

export class GardePartage implements IGardePartage {
    value?: GardePartageEnum;

    constructor(data?: IGardePartage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): GardePartage {
        data = typeof data === 'object' ? data : {};
        let result = new GardePartage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        return data;
    }
}

export interface IGardePartage {
    value?: GardePartageEnum;
}

export enum GardePartageEnum {
    MoinDeXPourcent = "MoinDeXPourcent",
    PlusDeXPourcent = "PlusDeXPourcent",
    Exclusive = "Exclusive",
}

export class ImageModel implements IImageModel {
    extension?: string | undefined;
    contenuBase64?: string | undefined;

    constructor(data?: IImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extension = _data["Extension"];
            this.contenuBase64 = _data["ContenuBase64"];
        }
    }

    static fromJS(data: any): ImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Extension"] = this.extension;
        data["ContenuBase64"] = this.contenuBase64;
        return data;
    }
}

export interface IImageModel {
    extension?: string | undefined;
    contenuBase64?: string | undefined;
}

export class ListItem implements IListItem {
    listItemId?: number;
    type?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    descriptionAnglais?: string | undefined;
    ordreTri?: number;
    codeOrganisme?: string | undefined;
    sourceCleNumerique?: number;
    sourceRowVersion?: number;

    constructor(data?: IListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listItemId = _data["ListItemId"];
            this.type = _data["Type"];
            this.value = _data["Value"];
            this.description = _data["Description"];
            this.descriptionAnglais = _data["DescriptionAnglais"];
            this.ordreTri = _data["OrdreTri"];
            this.codeOrganisme = _data["CodeOrganisme"];
            this.sourceCleNumerique = _data["SourceCleNumerique"];
            this.sourceRowVersion = _data["SourceRowVersion"];
        }
    }

    static fromJS(data: any): ListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ListItemId"] = this.listItemId;
        data["Type"] = this.type;
        data["Value"] = this.value;
        data["Description"] = this.description;
        data["DescriptionAnglais"] = this.descriptionAnglais;
        data["OrdreTri"] = this.ordreTri;
        data["CodeOrganisme"] = this.codeOrganisme;
        data["SourceCleNumerique"] = this.sourceCleNumerique;
        data["SourceRowVersion"] = this.sourceRowVersion;
        return data;
    }
}

export interface IListItem {
    listItemId?: number;
    type?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    descriptionAnglais?: string | undefined;
    ordreTri?: number;
    codeOrganisme?: string | undefined;
    sourceCleNumerique?: number;
    sourceRowVersion?: number;
}

export class Money implements IMoney {
    readonly value?: number;

    constructor(data?: IMoney) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).value = _data["Value"];
        }
    }

    static fromJS(data: any): Money {
        data = typeof data === 'object' ? data : {};
        let result = new Money();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        return data;
    }
}

export interface IMoney {
    value?: number;
}

export class Obnl implements IObnl {
    estSelectionne?: boolean | undefined;
    rechercheResidencePersonnesAgeesAvecServices?: boolean | undefined;
    projetParticulier?: string | undefined;
    serviceDesires?: string[] | undefined;

    constructor(data?: IObnl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estSelectionne = _data["EstSelectionne"];
            this.rechercheResidencePersonnesAgeesAvecServices = _data["RechercheResidencePersonnesAgeesAvecServices"];
            this.projetParticulier = _data["ProjetParticulier"];
            if (Array.isArray(_data["ServiceDesires"])) {
                this.serviceDesires = [] as any;
                for (let item of _data["ServiceDesires"])
                    this.serviceDesires!.push(item);
            }
        }
    }

    static fromJS(data: any): Obnl {
        data = typeof data === 'object' ? data : {};
        let result = new Obnl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EstSelectionne"] = this.estSelectionne;
        data["RechercheResidencePersonnesAgeesAvecServices"] = this.rechercheResidencePersonnesAgeesAvecServices;
        data["ProjetParticulier"] = this.projetParticulier;
        if (Array.isArray(this.serviceDesires)) {
            data["ServiceDesires"] = [];
            for (let item of this.serviceDesires)
                data["ServiceDesires"].push(item);
        }
        return data;
    }
}

export interface IObnl {
    estSelectionne?: boolean | undefined;
    rechercheResidencePersonnesAgeesAvecServices?: boolean | undefined;
    projetParticulier?: string | undefined;
    serviceDesires?: string[] | undefined;
}

export class Person implements IPerson {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    noPersonne?: number | undefined;
    demandeId?: number;
    prenom?: string | undefined;
    nom?: string | undefined;
    dateNaissance?: Date;
    sexe?: string | undefined;
    nas?: string | undefined;
    lien?: string | undefined;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    sousTutelleChefOuConjoint?: boolean;
    gardePartage?: GardePartage;
    revenuTotal?: Money;
    situation?: string | undefined;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreation = _data["DateCreation"] ? new Date(_data["DateCreation"].toString()) : undefined as any;
            this.rowVersion = _data["RowVersion"];
            this.id = _data["Id"];
            this.noPersonne = _data["NoPersonne"];
            this.demandeId = _data["DemandeId"];
            this.prenom = _data["Prenom"];
            this.nom = _data["Nom"];
            this.dateNaissance = _data["DateNaissance"] ? new Date(_data["DateNaissance"].toString()) : undefined as any;
            this.sexe = _data["Sexe"];
            this.nas = _data["Nas"];
            this.lien = _data["Lien"];
            this.etudiantTempsPlein = _data["EtudiantTempsPlein"];
            this.etudiantTempsPartiel = _data["EtudiantTempsPartiel"];
            this.handicapMoteur = _data["HandicapMoteur"];
            this.sousTutelleChefOuConjoint = _data["SousTutelleChefOuConjoint"];
            this.gardePartage = _data["GardePartage"] ? GardePartage.fromJS(_data["GardePartage"]) : undefined as any;
            this.revenuTotal = _data["RevenuTotal"] ? Money.fromJS(_data["RevenuTotal"]) : undefined as any;
            this.situation = _data["Situation"];
            this.pensionAlimentaire = _data["PensionAlimentaire"];
            this.pensionVeteran = _data["PensionVeteran"];
            this.assuranceInvalidite = _data["AssuranceInvalidite"];
            this.statutDeResidence = _data["StatutDeResidence"];
            this.paysDeNaissance = _data["PaysDeNaissance"];
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["RowVersion"] = this.rowVersion;
        data["Id"] = this.id;
        data["NoPersonne"] = this.noPersonne;
        data["DemandeId"] = this.demandeId;
        data["Prenom"] = this.prenom;
        data["Nom"] = this.nom;
        data["DateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        data["Sexe"] = this.sexe;
        data["Nas"] = this.nas;
        data["Lien"] = this.lien;
        data["EtudiantTempsPlein"] = this.etudiantTempsPlein;
        data["EtudiantTempsPartiel"] = this.etudiantTempsPartiel;
        data["HandicapMoteur"] = this.handicapMoteur;
        data["SousTutelleChefOuConjoint"] = this.sousTutelleChefOuConjoint;
        data["GardePartage"] = this.gardePartage ? this.gardePartage.toJSON() : undefined as any;
        data["RevenuTotal"] = this.revenuTotal ? this.revenuTotal.toJSON() : undefined as any;
        data["Situation"] = this.situation;
        data["PensionAlimentaire"] = this.pensionAlimentaire;
        data["PensionVeteran"] = this.pensionVeteran;
        data["AssuranceInvalidite"] = this.assuranceInvalidite;
        data["StatutDeResidence"] = this.statutDeResidence;
        data["PaysDeNaissance"] = this.paysDeNaissance;
        return data;
    }
}

export interface IPerson {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    noPersonne?: number | undefined;
    demandeId?: number;
    prenom?: string | undefined;
    nom?: string | undefined;
    dateNaissance?: Date;
    sexe?: string | undefined;
    nas?: string | undefined;
    lien?: string | undefined;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    sousTutelleChefOuConjoint?: boolean;
    gardePartage?: GardePartage;
    revenuTotal?: Money;
    situation?: string | undefined;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;
}

export class PersonneModel implements IPersonneModel {
    id?: string;
    noPersonne?: number | undefined;
    demandeId?: number;
    prenom?: string | undefined;
    nom?: string | undefined;
    dateNaissance?: Date;
    sexe?: string | undefined;
    nas?: string | undefined;
    lien?: string | undefined;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    sousTutelleChefOuConjoint?: boolean;
    gardePartage?: string | undefined;
    revenuTotal?: Money;
    situation?: string | undefined;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;

    constructor(data?: IPersonneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.noPersonne = _data["NoPersonne"];
            this.demandeId = _data["DemandeId"];
            this.prenom = _data["Prenom"];
            this.nom = _data["Nom"];
            this.dateNaissance = _data["DateNaissance"] ? new Date(_data["DateNaissance"].toString()) : undefined as any;
            this.sexe = _data["Sexe"];
            this.nas = _data["Nas"];
            this.lien = _data["Lien"];
            this.etudiantTempsPlein = _data["EtudiantTempsPlein"];
            this.etudiantTempsPartiel = _data["EtudiantTempsPartiel"];
            this.handicapMoteur = _data["HandicapMoteur"];
            this.sousTutelleChefOuConjoint = _data["SousTutelleChefOuConjoint"];
            this.gardePartage = _data["GardePartage"];
            this.revenuTotal = _data["RevenuTotal"] ? Money.fromJS(_data["RevenuTotal"]) : undefined as any;
            this.situation = _data["Situation"];
            this.pensionAlimentaire = _data["PensionAlimentaire"];
            this.pensionVeteran = _data["PensionVeteran"];
            this.assuranceInvalidite = _data["AssuranceInvalidite"];
            this.statutDeResidence = _data["StatutDeResidence"];
            this.paysDeNaissance = _data["PaysDeNaissance"];
        }
    }

    static fromJS(data: any): PersonneModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["NoPersonne"] = this.noPersonne;
        data["DemandeId"] = this.demandeId;
        data["Prenom"] = this.prenom;
        data["Nom"] = this.nom;
        data["DateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        data["Sexe"] = this.sexe;
        data["Nas"] = this.nas;
        data["Lien"] = this.lien;
        data["EtudiantTempsPlein"] = this.etudiantTempsPlein;
        data["EtudiantTempsPartiel"] = this.etudiantTempsPartiel;
        data["HandicapMoteur"] = this.handicapMoteur;
        data["SousTutelleChefOuConjoint"] = this.sousTutelleChefOuConjoint;
        data["GardePartage"] = this.gardePartage;
        data["RevenuTotal"] = this.revenuTotal ? this.revenuTotal.toJSON() : undefined as any;
        data["Situation"] = this.situation;
        data["PensionAlimentaire"] = this.pensionAlimentaire;
        data["PensionVeteran"] = this.pensionVeteran;
        data["AssuranceInvalidite"] = this.assuranceInvalidite;
        data["StatutDeResidence"] = this.statutDeResidence;
        data["PaysDeNaissance"] = this.paysDeNaissance;
        return data;
    }
}

export interface IPersonneModel {
    id?: string;
    noPersonne?: number | undefined;
    demandeId?: number;
    prenom?: string | undefined;
    nom?: string | undefined;
    dateNaissance?: Date;
    sexe?: string | undefined;
    nas?: string | undefined;
    lien?: string | undefined;
    etudiantTempsPlein?: boolean;
    etudiantTempsPartiel?: boolean;
    handicapMoteur?: boolean;
    sousTutelleChefOuConjoint?: boolean;
    gardePartage?: string | undefined;
    revenuTotal?: Money;
    situation?: string | undefined;
    pensionAlimentaire?: boolean | undefined;
    pensionVeteran?: boolean | undefined;
    assuranceInvalidite?: boolean | undefined;
    statutDeResidence?: string | undefined;
    paysDeNaissance?: string | undefined;
}

export class StringStringValuesKeyValuePair implements IStringStringValuesKeyValuePair {
    key?: string | undefined;
    value?: string[];

    constructor(data?: IStringStringValuesKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["Key"];
            if (Array.isArray(_data["Value"])) {
                this.value = [] as any;
                for (let item of _data["Value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringStringValuesKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringValuesKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key;
        if (Array.isArray(this.value)) {
            data["Value"] = [];
            for (let item of this.value)
                data["Value"].push(item);
        }
        return data;
    }
}

export interface IStringStringValuesKeyValuePair {
    key?: string | undefined;
    value?: string[];
}

export class Telephone implements ITelephone {
    telephone?: string | undefined;
    ext?: string | undefined;
    readonly extensionPrefix?: string | undefined;

    constructor(data?: ITelephone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.telephone = _data["telephone"];
            this.ext = _data["ext"];
            (this as any).extensionPrefix = _data["ExtensionPrefix"];
        }
    }

    static fromJS(data: any): Telephone {
        data = typeof data === 'object' ? data : {};
        let result = new Telephone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telephone"] = this.telephone;
        data["ext"] = this.ext;
        data["ExtensionPrefix"] = this.extensionPrefix;
        return data;
    }
}

export interface ITelephone {
    telephone?: string | undefined;
    ext?: string | undefined;
    extensionPrefix?: string | undefined;
}

export class TypeChambreur implements ITypeChambreur {
    value?: TypeChambreurEnum;

    constructor(data?: ITypeChambreur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): TypeChambreur {
        data = typeof data === 'object' ? data : {};
        let result = new TypeChambreur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        return data;
    }
}

export interface ITypeChambreur {
    value?: TypeChambreurEnum;
}

export enum TypeChambreurEnum {
    MaisonChambre = "MaisonChambre",
    ChezUnProche = "ChezUnProche",
    CentreHebergement = "CentreHebergement",
}

export class TypeDemandeur implements ITypeDemandeur {
    value?: TypeDemandeurEnum;

    constructor(data?: ITypeDemandeur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): TypeDemandeur {
        data = typeof data === 'object' ? data : {};
        let result = new TypeDemandeur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        return data;
    }
}

export interface ITypeDemandeur {
    value?: TypeDemandeurEnum;
}

export enum TypeDemandeurEnum {
    Locataire = "Locataire",
    Chambreur = "Chambreur",
    Proprietaire = "Proprietaire",
}

export class Vehicule implements IVehicule {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    personId?: number;
    demandeId?: number;
    marque?: string | undefined;
    modele?: string | undefined;
    annee?: string | undefined;

    constructor(data?: IVehicule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreation = _data["DateCreation"] ? new Date(_data["DateCreation"].toString()) : undefined as any;
            this.rowVersion = _data["RowVersion"];
            this.id = _data["Id"];
            this.personId = _data["PersonId"];
            this.demandeId = _data["DemandeId"];
            this.marque = _data["Marque"];
            this.modele = _data["Modele"];
            this.annee = _data["Annee"];
        }
    }

    static fromJS(data: any): Vehicule {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["RowVersion"] = this.rowVersion;
        data["Id"] = this.id;
        data["PersonId"] = this.personId;
        data["DemandeId"] = this.demandeId;
        data["Marque"] = this.marque;
        data["Modele"] = this.modele;
        data["Annee"] = this.annee;
        return data;
    }
}

export interface IVehicule {
    dateCreation?: Date;
    rowVersion?: string | undefined;
    id?: string;
    personId?: number;
    demandeId?: number;
    marque?: string | undefined;
    modele?: string | undefined;
    annee?: string | undefined;
}

export class VersionViewModel implements IVersionViewModel {
    versionDemandeEnLigne?: string | undefined;
    readonly versionDll?: string | undefined;

    constructor(data?: IVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionDemandeEnLigne = _data["VersionDemandeEnLigne"];
            (this as any).versionDll = _data["VersionDll"];
        }
    }

    static fromJS(data: any): VersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VersionDemandeEnLigne"] = this.versionDemandeEnLigne;
        data["VersionDll"] = this.versionDll;
        return data;
    }
}

export interface IVersionViewModel {
    versionDemandeEnLigne?: string | undefined;
    versionDll?: string | undefined;
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

// Fix pour NSwagStudio qui génère une erreur de syntax avec les im.port
}